// extracted by mini-css-extract-plugin
export var aggregationCell = "_2x-n";
export var aggregationRow = "_2x-m";
export var borderlessSpinnerContainer = "_2x-3";
export var cardLayout = "_2x-6";
export var cardLayoutNoFooter = "_2x-9";
export var cardLayoutPageControl = "_2x-8";
export var closeIcon = "_2x-f";
export var columnHeaderSurface = "_2x-b";
export var columnHeaderSurfaceDragOverlay = "_2x-v";
export var columnHeaderSurfaceResizing = "_2x-s";
export var contextMenuAnchor = "_2x-1";
export var draggableColumnHeader = "_2x-t";
export var draggableColumnHeaderOverlay = "_2x-u";
export var expandIcon = "_2x-g";
export var expanded = "_2x-h";
export var filterDropdown = "_2x-i";
export var filterDropdownDivider = "_2x-d";
export var filterDropdownHeader = "_2x-l";
export var filterDropdownItem = "_2x-k";
export var filterDropdownModal = "_2x-j _2x-i";
export var filterItem = "_2x-c";
export var normalCellWithAdjustableBorder = "_2x-e";
export var pinButtonContainer = "_2x-o";
export var pinIcon = "_2x-p";
export var pinIconActive = "_2x-q";
export var spinner = "_2x-0";
export var spinnerContainer = "_2x-2";
export var tableContainer = "_2x-4";
export var tableContentDraggingColumns = "_2x-a";
export var tableContentInner = "_2x-7";
export var tableContentWrapper = "_2x-5";
export var viewButtonContainer = "_2x-r";